<!-- eslint-disable vue/max-len -->
<template>
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1392_1962)">
      <path
        d="M22.3628 7.54242V13.6486L25.6339 9.72317L22.3628 7.54242Z"
        fill="currentColor"
      />
      <path
        d="M3.63729 7.54242L0.366211 9.72317L3.63729 13.6486V7.54242Z"
        fill="currentColor"
      />
      <path
        d="M17.8042 19.1191L20.8394 15.4768V0.761719C20.8394 0.341047 20.4983 0 20.0776 0H5.92236C5.50169 0 5.16064 0.341047 5.16064 0.761719V15.4768L8.19584 19.1191H17.8042ZM16.4404 15.4819H9.55957C9.1389 15.4819 8.79785 15.1409 8.79785 14.7202C8.79785 14.2995 9.1389 13.9585 9.55957 13.9585H16.4404C16.8611 13.9585 17.2021 14.2995 17.2021 14.7202C17.2021 15.1409 16.8611 15.4819 16.4404 15.4819ZM9.15119 4.12075C9.7371 3.53478 10.5162 3.21202 11.3449 3.21202C11.9398 3.21202 12.5093 3.37838 13 3.68911C13.4907 3.37843 14.0602 3.21202 14.6551 3.21202C15.4838 3.21202 16.2629 3.53473 16.8488 4.12075C18.0584 5.33036 18.0584 7.29853 16.8488 8.50814L13.5386 11.8184C13.3898 11.9671 13.1949 12.0415 13 12.0415C12.8051 12.0415 12.6101 11.9671 12.4614 11.8184L9.15119 8.50814C7.94158 7.29859 7.94158 5.33041 9.15119 4.12075Z"
        fill="currentColor"
      />
      <path
        d="M18.1609 20.6426H7.83905C7.61297 20.6426 7.39857 20.5421 7.2539 20.3685L0 11.6635V25.2383C0 25.6589 0.341047 26 0.761719 26H25.2383C25.659 26 26 25.6589 26 25.2383V11.6635L18.7461 20.3685C18.6014 20.5421 18.387 20.6426 18.1609 20.6426Z"
        fill="currentColor"
      />
      <path
        d="M12.9999 10.2025L15.7714 7.43094C16.3871 6.81532 16.3871 5.81356 15.7714 5.19794C15.4732 4.8997 15.0767 4.73547 14.655 4.73547C14.2332 4.73547 13.8367 4.8997 13.5385 5.19794C13.2411 5.49536 12.7587 5.49536 12.4613 5.19794C12.163 4.8997 11.7665 4.73547 11.3448 4.73547C10.923 4.73547 10.5266 4.8997 10.2283 5.19794C9.6127 5.81356 9.6127 6.81532 10.2283 7.43094L12.9999 10.2025Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1392_1962">
        <rect
          width="26"
          height="26"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
